import { Injectable } from '@angular/core';

/** Server-verified UTC clock independent of a device's wall clock or timezone. */
@Injectable({ providedIn: 'root' })
export class AuthServerClockService {
  private epochMs: number | null = null;
  private monotonicMs = 0;

  synchronize(timestamp: string | null | undefined): void {
    if (typeof timestamp !== 'string' ||
      !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/i.test(timestamp)) return;
    const epochMs = Date.parse(timestamp);
    if (!Number.isFinite(epochMs)) return;
    const current = this.nowMs();
    if (current !== null && epochMs < current - 1000) return;
    this.epochMs = epochMs;
    this.monotonicMs = performance.now();
  }

  nowMs(): number | null {
    return this.epochMs === null ? null : this.epochMs + Math.max(0, performance.now() - this.monotonicMs);
  }

  remainingMs(expirationSeconds: number): number | null {
    if (!Number.isFinite(expirationSeconds) || expirationSeconds <= 0) return null;
    const now = this.nowMs();
    return now === null ? null : expirationSeconds * 1000 - now;
  }

  /** null indicates no trusted clock; request revalidation, never trust Date.now(). */
  isExpired(expirationSeconds: number): boolean | null {
    const remaining = this.remainingMs(expirationSeconds);
    return remaining === null ? null : remaining <= 0;
  }
}
